import Text from "./Text";

export { SizeStyles } from "./Text.styled";
export type { Props as TextProps, Size as TextSize } from "./types";

export default Text;
